import React from 'react';
import Icon from '../Icon';
import HelperUtils from '@haptik/helpers/build/esm/platformUtils';

export default class ContextMenu extends React.Component {
  state = {
    options: [],
    position: {
      left: 0,
      top: 0,
    },
    active: false,
  };

  render() {
    const { options, position, active } = this.state;

    return (
      <div
        ref={element => {
          if (element) this._element = element;
        }}
        tabIndex="-1"
        onBlur={this.blur}
        className={`synonym-context-menu ${active ? 'active' : ''}`}
        style={{
          top: position.top,
          left: position.left,
        }}
      >
        {options.map((option, i) => {
          if (option) {
            return (
              <SynonymContextMenuItem
                key={i}
                {...option}
                onClick={e => this._handleClick(e, option.onClick)}
              />
            );
          }
        })}
      </div>
    );
  }

  _handleClick = (e, cb) => {
    this.blur();
    cb(e);
  };

  focus = (options, position, rect) => {
    if (!options.length > 0) return;
    const elementRect = this._element.getBoundingClientRect();
    position.left -= rect.x;
    const overflow = position.left + elementRect.width - rect.width;
    position.left -= overflow > -24 ? overflow + 24 : 0;
    if (this.props.offset) {
      position.top += this.props.offset.y || 0;
      position.left += this.props.offset.x || 0;
    }
    this.setState({ options, position }, () => {
      this.setState({ active: true });
    });
  };

  blur = () => {
    this.setState({ active: false });
  };
}

const SynonymContextMenuItem = ({ iconType, text, onClick, color }) => (
  <div className="synonym-context-menu-item" onClick={onClick}>
    <Icon
      iconType={iconType}
      className={`synonym-context-menu-item-icon ${color}`}
    />
    <span
      className="synonym-context-menu-item-text"
      dangerouslySetInnerHTML={{ __html: HelperUtils.htmlEscape(text) }}
    />
  </div>
);
